<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-items-center wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Header style</span>
    <span class="wf-w-1/2 wf-text-right">
      <select v-model="type" class="wf-w-full">
        <option value="DEFAULT">Default</option>
        <option value="SPLIT">Split</option>
        <option value="CENTER">Center</option>
        <option value="HAMBURGER">Hamburger</option>
        <option value="LEFT">Left</option>
      </select>
    </span>
  </li>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      type: {
        get() {
          return this.elementContent.type
        },
        set(value) {
          this.addToObject(this.module, {type: value}, 'content')
        }
      }
    }
  })
</script>